import type { MetadataFilter } from '../../../generated';
import { ReactiveMap } from '../../../utils/ReactiveMap';

export const ephemeralFiltersMap = new ReactiveMap<
  string,
  Array<MetadataFilter>,
  'ephemeralFiltersMap'
>('ephemeralFiltersMap');
ephemeralFiltersMap.clear();

export const recentSearchesMap = new ReactiveMap<
  string,
  Array<string>,
  'recentInProjectSearches'
>('recentInProjectSearches');
